var map = {
	"./custom/app/item-page/media-viewer/media-viewer-image/media-viewer-image.component": [
		8543,
		"src_themes_custom_app_item-page_media-viewer_media-viewer-image_media-viewer-image_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52636;
module.exports = webpackAsyncContext;